import { Locale } from 'constants/locale';

export const PARTNERSHIP_SLIDE_COUNT: Record<Locale, number> = {
  ko: 15,
  en: 13,
  ja: 13,
};
